// src/components/global/ToastProvider.tsx
"use client";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function ToastProvider() {
  return (
    <ToastContainer
      position="top-right"
      autoClose={5000}        // 5 seconds
      hideProgressBar
      closeOnClick
      pauseOnHover
      pauseOnFocusLoss
      draggable
      style={{ 
        marginTop: "80px", 
        zIndex: 9999,
        fontSize: "15px" 
      }}
    />
  );
}
